import { PageRequestDTO } from './page-request-dto';
import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface PagePerformedByRequestDTO extends PageRequestDTO, PerformedByRequestDTO {}
